
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActionNoteActionComplete": [
      "ActionComplete",
      "ActionNote"
    ],
    "Image": [
      "ActionAIContextImage",
      "ActionImage",
      "CompetitorSnapshotImage",
      "DisplaySnapshotImage",
      "PlanogramThumbnailImage",
      "ReferenceImage",
      "TenantLogoImage",
      "UserProfileImage"
    ],
    "InsightMetadata": [
      "IncompleteRestockMetadata",
      "IncompleteTaskMetadata",
      "PriceMismatchMetadata",
      "ProductNotSoldMetadata",
      "RecommendedSwapMetadata",
      "RevenueOutlierMetadata"
    ]
  }
};
      export default result;
    